import { Component, EventEmitter, Output, OnInit, NgZone } from '@angular/core';
import { ComponentBase, SettingsService } from 't4core';

declare global {
  interface Window {
    grecaptcha: any;
    recaptchaOnLoadCallback: () => void;
  }
}

@Component({
  selector: 'app-recaptcha',
  template: '',
  styleUrls: ['./recaptcha-authentication.component.css'],
  standalone: false
})
export class CaptchaComponent extends ComponentBase implements OnInit {
  @Output() verified = new EventEmitter<string>();

  private readonly siteKey = '6Lc42ZwrAAAAABvDKG_VVgtGIKYDLmNjbX7-rMHC';

  constructor(private settings: SettingsService, private ngZone: NgZone) {
    super();
  }

  ngOnInit(): void {
    this.loadRecaptchaScript().then(() => {
      this.executeRecaptcha();
    });
  }

  private loadRecaptchaScript(): Promise<void> {
    return new Promise((resolve) => {
      if (document.getElementById('recaptcha-script')) {
        resolve();
        return;
      }

      window.recaptchaOnLoadCallback = () => { 
        this.ngZone.run(() => resolve());
      };

      const script = document.createElement('script');
      script.id = 'recaptcha-script';
      script.src = 'https://www.google.com/recaptcha/enterprise.js?onload=recaptchaOnLoadCallback&render=' + this.siteKey;
      script.async = true;
      script.defer = true;

      document.head.appendChild(script);
    });
  }

  private executeRecaptcha() {
    const grecaptcha = window.grecaptcha;

    if (!grecaptcha || !grecaptcha.enterprise) {
      console.error('grecaptcha.enterprise is not available');
      return;
    }

    grecaptcha.enterprise.ready(() => {
      grecaptcha.enterprise.execute(this.siteKey, { action: 'login' }).then((token: string) => {
        this.ngZone.run(() => {
          this.verified.emit(token);
        });
      });
    });
  }
}
